export const abaNinjaApp = {
  id: 99,
  name: "abaninja",
  label: "AbaNinja",
  areaBlacklist: ["productSelection", "journal", "migration"],
  disableAdvancedSettings: true,
  showTestConnection: true,
  logo: process.env.BASE_URL + "media/shopLogos/abaninja.svg",
  additional_params: {
    requestHeaders: {
      Authorization: "Bearer {{key}}"
    },
    requestMethod: "GET",
    // "Get account" endpoint doubles as a status check: 200 = valid
    // token+account, 401/404 = invalid (no dedicated ping route exists).
    endpoint: "/accounts/v2/accounts/{{id}}"
  },
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_ABANINJA_PRESET_ID
  }
};
